import React, {useState, useEffect} from 'react';
import {Typography, Grid, Paper} from '@mui/material';
import Title from '../Common/Title';
import {Line, Circle} from 'rc-progress';

const boxShadowStyle = {
  boxShadow:
    '0 22px 25px 0 rgb(228 228 234 / 22%), 0 9px 23px 0 rgb(228 228 234 / 50%)',
  '&:hover': {
    boxShadow:
      '0 22px 32px 0 rgb(228 228 234 / 56%), 0 9px 28px 0 rgb(228 228 234 / 64%)',
  },
};

const PillarTile = ({pillar, linked, color, height}) => {
  return (
    <Grid item xs={12} md={6} lg={4}>
      <Paper
        sx={[
          {
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            padding: '36px 48px',
            borderRadius: '12px',
            height: height || null,
          },
          boxShadowStyle,
        ]}
        elevation={24}>
        <Title>{pillar.name}</Title>
        <div>
          <Typography color="text.secondary" sx={{flex: 1}}>
            Average account balance
          </Typography>
          <Typography
            component="p"
            variant="h4"
            sx={{
              fontSize: '46px',
              fontWeight: '500',
              letterSpacing: '1.2px',
              lineHeight: '44px',
              margin: '8px',
              textAlign: 'center',
            }}>
            ${pillar.average.toFixed(2)}
          </Typography>
        </div>
        <div>
          <Typography color="text.secondary" sx={{flex: 1}}>
            Students with accounts
          </Typography>
          <div style={{display: 'flex', flexDirection: 'row', flex: 1}}>
            <Line
              percent={(pillar.users / linked) * 100}
              strokeWidth={3}
              trailWidth={2}
              strokeColor={color}
              style={{flex: 1, alignSelf: 'center'}}
            />
            <Typography
              component="p"
              variant="h5"
              sx={{marginLeft: '4px', fontSize: 22}}>
              {pillar.users}
            </Typography>
          </div>
        </div>
        {pillar.goalCreated !== undefined && (
          <div>
            <Typography color="text.secondary" sx={{flex: 1}}>
              Students with active goals set
            </Typography>
            <div style={{display: 'flex', flexDirection: 'row', flex: 1}}>
              <Line
                percent={(pillar.goalCreated / linked) * 100}
                strokeWidth={3}
                trailWidth={2}
                strokeColor={color}
                style={{flex: 1, alignSelf: 'center'}}
              />
              <Typography
                component="p"
                variant="h5"
                sx={{marginLeft: '4px', fontSize: 22}}>
                {pillar.goalCreated}
              </Typography>
            </div>
          </div>
        )}
        {pillar.utilization !== undefined && (
          <div>
            <Typography color="text.secondary" sx={{flex: 1}}>
              Credit Utilization
            </Typography>
            <div style={{display: 'flex', flexDirection: 'row', flex: 1}}>
              <Line
                percent={pillar.utilization}
                strokeWidth={3}
                trailWidth={2}
                strokeColor={color}
                style={{flex: 1, alignSelf: 'center'}}
              />
              <Typography
                component="p"
                variant="h5"
                sx={{marginLeft: '4px', fontSize: 18}}>
                {pillar.utilization.toFixed(2)}%
              </Typography>
            </div>
          </div>
        )}
      </Paper>
    </Grid>
  );
};

export default PillarTile;
